export const cfcVsBfcMyContestList = [
  {
    _id: '63d11ad38d8436001e1bed5b',
    createdOn: '2022-10-08T06:32:47.030Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cb',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'H2H 20',
    description: 'Head To Head',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 3500,
    entryFee: 2000,
    winningsPerPosition: {
      '3500': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 500,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    isCanceled: false,
    status: 1,
    statusText: 'scheduled',
    gameState: 0,
    gameStateText: 'None',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1
  }
];
export const odiVsBfcMyContestList = [
  {
    _id: '635a2c53027fb4001b93a107',
    createdOn: '2022-10-08T06:51:23.993Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '618284340d1e16001ef3297e',
    tenant: 'dev',
    title: 'giveaway',
    description: 'giveaway',
    minimumPlayers: 100000,
    maximumPlayers: 100000,
    maxTeamPerUser: 11,
    winningsAmount: 5000000,
    entryFee: 0,
    winningsPerPosition: {
      '1100': 1000,
      '30000': 50,
      '40000': 10,
      '50000': 10,
      '100000': 1,
      '200000': 1,
      '300000': 1,
      '400000': 1,
      '500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '6352d31ce1e4df00fa125db2',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 12,
    modifiedOn: '2022-10-27T18:24:01.117Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '635a2c90027fb4001b93a114',
        contestId: '635a2c53027fb4001b93a107',
        tenant: 'dev',
        matchTeamId: '635a2c85027fb4001b93a110',
        userId: '601cd58656c4dd5b565191e9',
        winning: 500000,
        rank: 1,
        createdOn: '2022-10-27T07:00:32.956Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  },
  {
    _id: '635a2c53027fb4001b93a105',
    createdOn: '2022-10-08T06:48:15.874Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'GL 25K',
    description: 'GL',
    minimumPlayers: 1000,
    maximumPlayers: 1000,
    maxTeamPerUser: 11,
    winningsAmount: 2500000,
    entryFee: 3000,
    winningsPerPosition: {
      '9000': 100,
      '30000': 20,
      '40000': 5,
      '50000': 2,
      '100000': 1,
      '200000': 1,
      '400000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 500000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6352d31ce1e4df00fa125db2',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 12,
    modifiedOn: '2022-10-27T18:24:01.117Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '635a2c8c027fb4001b93a111',
        contestId: '635a2c53027fb4001b93a105',
        tenant: 'dev',
        matchTeamId: '635a2c85027fb4001b93a110',
        userId: '601cd58656c4dd5b565191e9',
        winning: 400000,
        rank: 1,
        createdOn: '2022-10-27T07:00:28.470Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  },
  {
    _id: '635a2c53027fb4001b93a109',
    createdOn: '2022-10-08T06:32:47.030Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cb',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'H2H 20',
    description: 'Head To Head',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 3500,
    entryFee: 2000,
    winningsPerPosition: {
      '3500': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 500,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6352d31ce1e4df00fa125db2',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    modifiedOn: '2022-10-27T18:24:01.117Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '635a2ca0027fb4001b93a11d',
        contestId: '635a2c53027fb4001b93a109',
        tenant: 'dev',
        matchTeamId: '635a2c85027fb4001b93a110',
        userId: '601cd58656c4dd5b565191e9',
        winning: 3500,
        rank: 1,
        createdOn: '2022-10-27T07:00:48.326Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cb',
      slug: 'head_to_head',
      acceptsMultipleEntry: false,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description: 'A contest involving 2 people where the winner takes all',
      requireValidationChecks: true,
      title: 'Head to Head'
    }
  },
  {
    _id: '635a2c53027fb4001b93a10b',
    createdOn: '2022-10-08T06:31:30.892Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cb',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'H2H 5',
    description: 'Head to head',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 900,
    entryFee: 500,
    winningsPerPosition: {
      '900': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6352d31ce1e4df00fa125db2',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    modifiedOn: '2022-10-27T18:24:01.117Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '635a2ca5027fb4001b93a120',
        contestId: '635a2c53027fb4001b93a10b',
        tenant: 'dev',
        matchTeamId: '635a2c85027fb4001b93a110',
        userId: '601cd58656c4dd5b565191e9',
        winning: 900,
        rank: 1,
        createdOn: '2022-10-27T07:00:53.414Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cb',
      slug: 'head_to_head',
      acceptsMultipleEntry: false,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description: 'A contest involving 2 people where the winner takes all',
      requireValidationChecks: true,
      title: 'Head to Head'
    }
  }
];
export const cfcVsBfcResultMyContestList = [
  {
    _id: '63451e71c2760c001bcd40f9',
    createdOn: '2022-10-08T06:51:23.993Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '618284340d1e16001ef3297e',
    tenant: 'dev',
    title: 'giveaway',
    description: 'giveaway',
    minimumPlayers: 100000,
    maximumPlayers: 100000,
    maxTeamPerUser: 11,
    winningsAmount: 5000000,
    entryFee: 0,
    winningsPerPosition: {
      '1100': 1000,
      '30000': 50,
      '40000': 10,
      '50000': 10,
      '100000': 1,
      '200000': 1,
      '300000': 1,
      '400000': 1,
      '500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '63445a1c746a9884afab2c59',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 31,
    modifiedOn: '2022-10-14T18:48:00.963Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6349669eb99cfd001d9cf518',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '63496691b99cfd001d9cf514',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 11,
        createdOn: '2022-10-14T13:39:42.541Z',
        deletedOn: null
      },
      {
        _id: '634966d4b99cfd001d9cf532',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '634966b2b99cfd001d9cf51e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 6,
        createdOn: '2022-10-14T13:40:36.842Z',
        deletedOn: null
      },
      {
        _id: '634966d4b99cfd001d9cf533',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '634966b7b99cfd001d9cf51f',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 7,
        createdOn: '2022-10-14T13:40:36.842Z',
        deletedOn: null
      },
      {
        _id: '634966d4b99cfd001d9cf534',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '634966bcb99cfd001d9cf520',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 10,
        createdOn: '2022-10-14T13:40:36.842Z',
        deletedOn: null
      },
      {
        _id: '634966d4b99cfd001d9cf535',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '634966c2b99cfd001d9cf521',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 9,
        createdOn: '2022-10-14T13:40:36.842Z',
        deletedOn: null
      },
      {
        _id: '634966d4b99cfd001d9cf536',
        contestId: '63451e71c2760c001bcd40f9',
        tenant: 'dev',
        matchTeamId: '634966c7b99cfd001d9cf522',
        userId: '601cd58656c4dd5b565191e9',
        winning: 350000,
        rank: 2,
        createdOn: '2022-10-14T13:40:36.842Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  },
  {
    _id: '6348e2e6b99cfd001d9cf26f',
    createdOn: '2022-10-08T06:51:23.993Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '618284340d1e16001ef3297e',
    tenant: 'dev',
    title: 'giveaway',
    description: 'giveaway',
    minimumPlayers: 100000,
    maximumPlayers: 100000,
    maxTeamPerUser: 11,
    winningsAmount: 5000000,
    entryFee: 0,
    winningsPerPosition: {
      '1100': 1000,
      '30000': 50,
      '40000': 10,
      '50000': 10,
      '100000': 1,
      '200000': 1,
      '300000': 1,
      '400000': 1,
      '500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '63445a1c746a9884afab2c59',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 29,
    modifiedOn: '2022-10-14T18:48:00.963Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '634966dbb99cfd001d9cf541',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '63496691b99cfd001d9cf514',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 11,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      },
      {
        _id: '634966dbb99cfd001d9cf542',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '634966b2b99cfd001d9cf51e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 6,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      },
      {
        _id: '634966dbb99cfd001d9cf543',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '634966b7b99cfd001d9cf51f',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 7,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      },
      {
        _id: '634966dbb99cfd001d9cf544',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '634966bcb99cfd001d9cf520',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 10,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      },
      {
        _id: '634966dbb99cfd001d9cf545',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '634966c2b99cfd001d9cf521',
        userId: '601cd58656c4dd5b565191e9',
        winning: 50000,
        rank: 9,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      },
      {
        _id: '634966dbb99cfd001d9cf546',
        contestId: '6348e2e6b99cfd001d9cf26f',
        tenant: 'dev',
        matchTeamId: '634966c7b99cfd001d9cf522',
        userId: '601cd58656c4dd5b565191e9',
        winning: 350000,
        rank: 2,
        createdOn: '2022-10-14T13:40:43.165Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  },
  {
    _id: '6348e2e6b99cfd001d9cf26d',
    createdOn: '2022-10-08T06:48:15.874Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'GL 25K',
    description: 'GL',
    minimumPlayers: 1000,
    maximumPlayers: 1000,
    maxTeamPerUser: 11,
    winningsAmount: 2500000,
    entryFee: 3000,
    winningsPerPosition: {
      '9000': 100,
      '30000': 20,
      '40000': 5,
      '50000': 2,
      '100000': 1,
      '200000': 1,
      '400000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 500000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63445a1c746a9884afab2c59',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 29,
    modifiedOn: '2022-10-14T18:48:00.963Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '63496699b99cfd001d9cf515',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '63496691b99cfd001d9cf514',
        userId: '601cd58656c4dd5b565191e9',
        winning: 30000,
        rank: 11,
        createdOn: '2022-10-14T13:39:37.114Z',
        deletedOn: null
      },
      {
        _id: '634966cfb99cfd001d9cf523',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '634966b2b99cfd001d9cf51e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 40000,
        rank: 6,
        createdOn: '2022-10-14T13:40:31.123Z',
        deletedOn: null
      },
      {
        _id: '634966cfb99cfd001d9cf524',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '634966b7b99cfd001d9cf51f',
        userId: '601cd58656c4dd5b565191e9',
        winning: 40000,
        rank: 7,
        createdOn: '2022-10-14T13:40:31.123Z',
        deletedOn: null
      },
      {
        _id: '634966cfb99cfd001d9cf525',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '634966bcb99cfd001d9cf520',
        userId: '601cd58656c4dd5b565191e9',
        winning: 40000,
        rank: 10,
        createdOn: '2022-10-14T13:40:31.123Z',
        deletedOn: null
      },
      {
        _id: '634966cfb99cfd001d9cf526',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '634966c2b99cfd001d9cf521',
        userId: '601cd58656c4dd5b565191e9',
        winning: 40000,
        rank: 9,
        createdOn: '2022-10-14T13:40:31.123Z',
        deletedOn: null
      },
      {
        _id: '634966cfb99cfd001d9cf527',
        contestId: '6348e2e6b99cfd001d9cf26d',
        tenant: 'dev',
        matchTeamId: '634966c7b99cfd001d9cf522',
        userId: '601cd58656c4dd5b565191e9',
        winning: 150000,
        rank: 2,
        createdOn: '2022-10-14T13:40:31.123Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  }
];

export const atkMBVsCfcMyContestList = [
  {
    _id: '6343c0dec2760c001bcd403b',
    createdOn: '2022-10-08T06:51:23.993Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '618284340d1e16001ef3297e',
    tenant: 'dev',
    title: 'giveaway',
    description: 'giveaway',
    minimumPlayers: 100000,
    maximumPlayers: 100000,
    maxTeamPerUser: 11,
    winningsAmount: 5000000,
    entryFee: 0,
    winningsPerPosition: {
      '1100': 1000,
      '30000': 50,
      '40000': 10,
      '50000': 10,
      '100000': 1,
      '200000': 1,
      '300000': 1,
      '400000': 1,
      '500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '633ec64c746a9884af15dc05',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 16,
    modifiedOn: '2022-10-10T19:28:01.411Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: false,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6343f00bc2760c001bcd40b2',
        contestId: '6343c0dec2760c001bcd403b',
        tenant: 'dev',
        matchTeamId: '6343eaafc2760c001bcd40ad',
        userId: '601cd58656c4dd5b565191e9',
        winning: 500000,
        rank: 1,
        createdOn: '2022-10-10T10:12:27.071Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-10-13T07:27:43.135Z'
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  },
  {
    _id: '6343c0dec2760c001bcd4043',
    createdOn: '2022-10-08T06:48:15.874Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'GL 25K',
    description: 'GL',
    minimumPlayers: 1000,
    maximumPlayers: 1000,
    maxTeamPerUser: 11,
    winningsAmount: 2500000,
    entryFee: 3000,
    winningsPerPosition: {
      '9000': 100,
      '30000': 20,
      '40000': 5,
      '50000': 2,
      '100000': 1,
      '200000': 1,
      '400000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 500000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '633ec64c746a9884af15dc05',
    isCanceled: false,
    status: 2,
    statusText: 'result',
    gameState: 6,
    gameStateText: 'Ended',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 5,
    modifiedOn: '2022-10-10T19:28:01.411Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: false,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6343f005c2760c001bcd40af',
        contestId: '6343c0dec2760c001bcd4043',
        tenant: 'dev',
        matchTeamId: '6343eaafc2760c001bcd40ad',
        userId: '601cd58656c4dd5b565191e9',
        winning: 400000,
        rank: 1,
        createdOn: '2022-10-10T10:12:21.871Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-10-13T07:27:42.066Z'
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  }
];
export const jfcVsMcfMyContestList = [
  {
    _id: '63d33d508d8436001e1bedb2',
    createdOn: '2022-10-08T06:31:30.892Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cb',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'H2H 5',
    description: 'Head to head',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 900,
    entryFee: 500,
    winningsPerPosition: {
      '900': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63cb03286bc8d3ddb965e21b',
    isCanceled: false,
    status: 1,
    statusText: 'upcoming',
    gameState: 1,
    gameStateText: 'Not started',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    modifiedOn: '2023-01-27T03:00:00.339Z',
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d33e3b8d8436001e1bedb9',
        contestId: '63d33d508d8436001e1bedb2',
        tenant: 'dev',
        matchTeamId: '63d33e348d8436001e1bedb8',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-27T03:00:11.171Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cb',
      slug: 'head_to_head',
      acceptsMultipleEntry: false,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description: 'A contest involving 2 people where the winner takes all',
      requireValidationChecks: true,
      title: 'Head to Head'
    }
  }
];
export const kerVsNorMyContestList = [
  {
    _id: '63d35b078d8436001e1bedf8',
    createdOn: '2023-01-27T04:57:41.157Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '61821e0cb2569b001f9ddf50',
    tenant: 'dev',
    title: 'Win More1',
    description: 'Win More',
    minimumPlayers: 100,
    maximumPlayers: 150,
    maxTeamPerUser: 8,
    winningsAmount: 10000,
    entryFee: 100,
    winningsPerPosition: {
      '3000': 1,
      '7000': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '63d29ad46bc8d3ddb9782e01',
    isCanceled: false,
    status: 1,
    statusText: 'upcoming',
    gameState: 1,
    gameStateText: 'Not started',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    modifiedOn: '2023-01-27T12:10:00.516Z',
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d3bf278d8436001e1bee01',
        contestId: '63d35b078d8436001e1bedf8',
        tenant: 'dev',
        matchTeamId: '63d341578d8436001e1bedc0',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-27T12:10:15.179Z',
        deletedOn: null
      },
      {
        _id: '63d3bf408d8436001e1bee06',
        contestId: '63d35b078d8436001e1bedf8',
        tenant: 'dev',
        matchTeamId: '63d3bf3a8d8436001e1bee05',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-27T12:10:40.016Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  }
];
export const atkVsOdiMyContestList = [
  {
    _id: '63d35aeb8d8436001e1bedee',
    createdOn: '2023-01-27T04:57:41.157Z',
    deletedOn: null,
    contestTypeId: '628747cdc76dd0419be8e2cd',
    contestCategoryId: '61821e0cb2569b001f9ddf50',
    tenant: 'dev',
    title: 'Win More1',
    description: 'Win More',
    minimumPlayers: 100,
    maximumPlayers: 150,
    maxTeamPerUser: 8,
    winningsAmount: 10000,
    entryFee: 100,
    winningsPerPosition: {
      '3000': 1,
      '7000': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '63cda4c06bc8d3ddb9c91f39',
    isCanceled: false,
    status: 1,
    statusText: 'upcoming',
    gameState: 1,
    gameStateText: 'Not started',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    modifiedOn: '2023-01-27T12:17:00.512Z',
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d3c0d88d8436001e1bee0b',
        contestId: '63d35aeb8d8436001e1bedee',
        tenant: 'dev',
        matchTeamId: '63d3c0d48d8436001e1bee0a',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-27T12:17:28.181Z',
        deletedOn: null
      },
      {
        _id: '63d3c0ef8d8436001e1bee10',
        contestId: '63d35aeb8d8436001e1bedee',
        tenant: 'dev',
        matchTeamId: '63d3c0eb8d8436001e1bee0f',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-27T12:17:51.190Z',
        deletedOn: null
      }
    ],
    contestType: {
      _id: '628747cdc76dd0419be8e2cd',
      slug: 'multiple_player_multiple_entry',
      acceptsMultipleEntry: true,
      createdOn: '2022-12-23T09:39:16.171Z',
      deletedOn: null,
      description:
        'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
      requireValidationChecks: true,
      title: 'Multiple Players, Multiple Entries'
    }
  }
];
